import { forwardRef, cloneElement } from 'react';

function cloneComponent(component) {
    return forwardRef(function Wrapper(props, ref) {
        const propsToPass = Object.assign({}, props);
        Reflect.deleteProperty(propsToPass, "sx");
        Reflect.deleteProperty(propsToPass, "theme");
        return cloneElement(component, Object.assign(Object.assign({}, propsToPass), { ref }));
    });
}

export { cloneComponent };
//# sourceMappingURL=cloneComponent.js.map
